/** Whether Nexus Blocks was opened from Connected Center for community publishing. */
export const isConnectedCenterMode = () => {
    if (typeof location === 'undefined') {
        return false;
    }
    const params = new URLSearchParams(location.search);
    return params.get('connected_center') === '1' || params.get('cc_publish') === '1';
};

/** Allow iframe embedding when opened from Nexus / Connected Center. */
export const isNexusEmbedAllowed = () => {
    if (typeof location === 'undefined') {
        return false;
    }
    const params = new URLSearchParams(location.search);
    return params.get('connected_center') === '1'
        || params.get('cc_publish') === '1'
        || params.get('nexus_embed') === '1';
};

/** API endpoint for one-click community game upload. */
export const getConnectedCenterUploadUrl = () => {
    if (typeof location === 'undefined') {
        return '../../connectedcenternew/api/upload_community_game.php';
    }
    const params = new URLSearchParams(location.search);
    const override = params.get('cc_upload');
    if (override) {
        return override;
    }
    return '../../connectedcenternew/api/upload_community_game.php';
};

export const getConnectedCenterApiBase = () => {
    const upload = getConnectedCenterUploadUrl();
    const idx = upload.indexOf('/api/');
    if (idx === -1) {
        return '../../connectedcenternew';
    }
    return upload.slice(0, idx);
};

export const getEditingGameId = () => {
    if (typeof location === 'undefined') {
        return null;
    }
    const raw = new URLSearchParams(location.search).get('cc_game_id');
    if (!raw) {
        return null;
    }
    const id = parseInt(raw, 10);
    return Number.isFinite(id) && id > 0 ? id : null;
};

/** Stable TurboWarp cloud room for a published community game (shared by all players). */
export const getCommunityCloudProjectId = () => {
    const gameId = getEditingGameId();
    if (!gameId) {
        return null;
    }
    return `sync.nexus/cg/${gameId}`;
};

export const ccApiUrl = (endpoint) => {
    const base = getConnectedCenterApiBase();
    return `${base}/api/${endpoint}`;
};
